import { ReactNode } from 'react';
import { usePosLiteAccount } from 'src/hooks/usePosLiteAccount';

interface SalesBulkActionsPermissionsProps {
  children: ReactNode;
}

// TODO: Feature is now GA, need to clean this up.
export const SalesBulkActionsPermissions = ({
  children,
}: SalesBulkActionsPermissionsProps) => {
  const isPosLite = usePosLiteAccount();

  if (isPosLite) {
    return null;
  }

  return <>{children}</>;
};
